
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "48px",
    "height": "48px",
    "viewBox": "0 0 48 48",
    "enable-background": "new 0 0 48 48",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "y": "0",
        "display": "none",
        "fill": "#F2F2F2",
        "width": "48",
        "height": "48"
      }
    },
    {
      "tag": "circle",
      "attrsMap": {
        "fill": "#B7C3D7",
        "cx": "24",
        "cy": "24",
        "r": "24"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#FFFFFF",
        "d": "M30.465,14.861c0.942,0,1.711-0.769,1.711-1.711V9.73c0-0.94-0.769-1.71-1.711-1.71\r\n\tc-0.94,0-1.709,0.77-1.709,1.71v3.42C28.756,14.092,29.524,14.861,30.465,14.861z M36.109,11.441H32.86v1.709\r\n\tc0,1.316-1.077,2.394-2.396,2.394c-1.316,0-2.393-1.078-2.393-2.394v-1.709h-7.183v1.709c0,1.316-1.077,2.394-2.395,2.394\r\n\tc-1.316,0-2.395-1.078-2.395-2.394v-1.709h-3.248c-0.941,0-1.711,0.769-1.711,1.709v23.121c0,0.942,0.77,1.711,1.711,1.711h23.258\r\n\tc0.939,0,1.711-0.769,1.711-1.711V13.15C37.82,12.21,37.049,11.441,36.109,11.441z M18.494,14.861c0.941,0,1.711-0.769,1.711-1.711\r\n\tV9.73c0-0.94-0.77-1.71-1.711-1.71c-0.94,0-1.71,0.77-1.71,1.71v3.42C16.784,14.092,17.554,14.861,18.494,14.861z"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#B7C3D7",
        "d": "M28.912,27.075c0.762,0,1.38-0.617,1.38-1.38s-0.618-1.38-1.38-1.38h-2.013l3.185-3.639\r\n\tc0.511-0.566,0.466-1.438-0.1-1.947c-0.566-0.512-1.438-0.463-1.949,0.104l-3.528,3.852l-3.591-3.877\r\n\tc-0.52-0.561-1.391-0.568-1.95-0.051c-0.56,0.517-0.595,1.445-0.079,2.005l3.209,3.554h-1.842c-0.762,0-1.379,0.617-1.379,1.38\r\n\ts0.617,1.38,1.379,1.38h2.791v1.569h-2.791c-0.762,0-1.379,0.618-1.379,1.38s0.617,1.381,1.379,1.381h2.791v1.137\r\n\tc0,0.85,0.688,1.539,1.539,1.539c0.85,0,1.538-0.689,1.538-1.539v-1.137h2.79c0.762,0,1.38-0.619,1.38-1.381s-0.618-1.38-1.38-1.38\r\n\th-2.79v-1.569H28.912z"
      }
    }
  ]
})
    }
  